import React from "react";
import { match } from "ts-pattern";

import "./button.scss";

/*
 * Types
 */

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    readonly variation?: "icon" | "primary" | "secondary" | "outline";
}

/*
 * Main
 */

export const Button = (props: ButtonProps): React.ReactElement => {
    const { children, onClick, variation = "primary", ...rest } = props;

    const getVariationCss = (): string => {
        return match(variation)
            .with("icon", () => {
                return ["button-style", "light-blue"].join(" ");
            })
            .with("primary", () => {
                return ["button-style"].join("");
            })
            .with("secondary", () => {
                return ["button-style", "gold"].join(" ");
            })
            .with("outline", () => {
                return ["button-style", "save-progress"].join(" ");
            })
            .exhaustive();
    };

    return (
        <button className={getVariationCss()} onClick={onClick && onClick} {...rest}>
            {children}
        </button>
    );
};
